"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var icons_1 = require("../../../../../../icons");
var utils_1 = require("../../../../../../utils");
var Badge_1 = __importDefault(require("../../../../Badge"));
var getTooltipBadgeState = function (value) {
    if (value < 0) {
        return 'error';
    }
    else {
        return 'success';
    }
};
var DeltaBadge = function (_a) {
    var value = _a.value, unit = _a.unit;
    var tooltipBadgeState = react_2.useMemo(function () { return getTooltipBadgeState(value); }, [value]);
    return (react_1.jsx(Badge_1.default, { color: tooltipBadgeState === 'success' ? 'success' : 'error', mode: 'dark', icon: tooltipBadgeState === 'success' ? icons_1.ArrowNarrowUp : icons_1.ArrowNarrowDown }, utils_1.formatNumber(Math.abs(value), { unit: unit })));
};
exports.default = DeltaBadge;
